const r = (t = 0) => new Promise((e) => {
  setTimeout(() => {
    e(!0);
  }, 1e4);
});
export {
  r as default
};
